import axios from 'axios';
import Fuse from 'fuse.js';

const INITIAL_STATE = {
  isLoading: false,
  featuredSermons: [],
  categories: [],
  topics: [],
  pastors: [],
  viewedSermon: {},
  searchSuggestions: [],
  resources: [],
  searchClient: null,
  showSearchResults: false,
  showSearch: false,
};

const state = () => INITIAL_STATE;

let getAllSermonsRequest = null;

const mutations = {
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setFeaturedSermons(state, featuredSermons) {
    state.featuredSermons = featuredSermons;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setTopics(state, topics) {
    state.topics = topics;
  },
  setPastors(state, pastors) {
    state.pastors = pastors;
  },
  updateViewedSermon(state, data) {
    state.viewedSermon = data;
  },
  setSearchSuggestions(state, searchSuggestions) {
    state.searchSuggestions = searchSuggestions;
  },
  setResources(state, resources) {
    state.resources = resources;
  },
  setShowSearch(state, showSearch) {
    state.showSearch = showSearch;
  },
  setShowSearchResults(state, showSearchResults) {
    state.showSearchResults = showSearchResults;
  },
  setSearchClient(state, resources) {
    const combinedResourcesArray = [];
    resources.forEach(item => {
      combinedResourcesArray.push(item);
    });
    state.searchClient = new Fuse(combinedResourcesArray, {
      keys: ['title', 'description', 'pastors', 'topics', 'date'],
      includeScore: true,
      threshold: 0.1,
      ignoreLocation: true,
    });
  },
};

const actions = {
  async getAllSermons({ state, commit, dispatch, rootState }, options = {}) {
    const force = options?.force === true;

    if (!force && state.resources?.length > 0) {
      return state.resources;
    }

    if (getAllSermonsRequest) {
      return getAllSermonsRequest;
    }

    commit('setIsLoading', true);

    getAllSermonsRequest = (async () => {
      try {
        const accessToken = rootState.user.token;
        const { status, data } = await axios.get(
          process.env.VUE_APP_API_URL + '/library/landing-page-resources',
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (status !== 200) throw new Error('Failed in getting sermons');

        commit('setFeaturedSermons', data.featuredSermons);
        commit('setCategories', data.categories);
        commit('setTopics', data.topics);
        commit('setPastors', data.pastors);
        commit('setSearchSuggestions', data.searchSuggestions);
        commit('setResources', data.resources);
        commit('setSearchClient', data.resources);
        return data;
      } catch (e) {
        console.error('[LIBRARY STORE] Error in getAllSermons:', e);
        dispatch('toast/error', 'Failed to get sermons for Library feature.', {
          root: true,
        });
        return null;
      } finally {
        commit('setIsLoading', false);
        getAllSermonsRequest = null;
      }
    })();

    return getAllSermonsRequest;
  },

  async fetchSermon({ commit, dispatch, rootState }, slug) {
    try {
      const accessToken = rootState.user.token;
      const { status, data } = await axios.get(
        process.env.VUE_APP_API_URL + `/library/sermons/` + slug,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      commit('updateViewedSermon', data);
    } catch (e) {
      dispatch('toast/error', 'Failed to get sermon', {
        root: true,
      });
    }
  },

  updateShowSearchResults({ commit }, showSearchResults) {
    commit('setShowSearchResults', showSearchResults);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
